import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveRem3Failure, saveRem3Success, updateRem3Failure, updateRem3Success } from './actions';

export function* saveRem3({ payload }) {
  try {
    yield call(api.post, 'api/rem3', payload.data, { withCredentials: true });

    yield put(saveRem3Success());

    toast.success('REM3 criado com sucesso!')

    history.push('/specifications/pilar3/resources/rem3');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveRem3Failure());
  }
}

export function* updateRem3({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/rem3/${id}`, payload.data, { withCredentials: true });

    yield put(updateRem3Success());

    toast.success('REM3 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/rem3');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateRem3Failure());
  }
}

export default all([
  takeLatest('@rem3/SAVE_REQUEST', saveRem3),
  takeLatest('@rem3/UPDATE_REQUEST', updateRem3)
]);